import { render, staticRenderFns } from "./EllipseSwiper.vue?vue&type=template&id=9cba668e&"
import script from "./EllipseSwiper.vue?vue&type=script&lang=js&"
export * from "./EllipseSwiper.vue?vue&type=script&lang=js&"
import style0 from "./EllipseSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports